import { updatePlayerBooleanSetting } from "@dailywars/core/db";
import { createServerFn } from "@tanstack/react-start";

import { updateGameplaySettingInputSchema } from "#/lib/playerSettingsSchemas";
import { getRequestLogger, logRequestError } from "#/lib/requestLogger.server";
import { authedMiddleware } from "#/server/authedMiddleware";

export const updateMyGameplaySetting = createServerFn({ method: "POST" })
  .middleware([authedMiddleware])
  .validator(updateGameplaySettingInputSchema)
  .handler(async ({ context, data }) => {
    getRequestLogger().set({
      profile: { action: "update_gameplay_setting", setting: data.setting },
    });
    try {
      await updatePlayerBooleanSetting({
        playerId: context.userId,
        setting: data.setting,
        enabled: data.enabled,
      });
    } catch (error) {
      logRequestError({
        log: getRequestLogger(),
        error,
        context: { profile: { step: "update_gameplay_setting", setting: data.setting } },
      });
      throw error;
    }
  });
